module.exports = __webpack_public_path__ + "img/30.988bf5f2.png";